import {getStore} from 'src/v2/state/store';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Text} from 'src/v2/components/common/Text';
import {LinkTitleWrapper} from 'src/v2/components/screen/link/LinkTitleWrapper';
import {isUsdtAssetCode} from 'src/utils/helpers';
import {useAmountDisplay} from 'src/v2/state/useAmountDisplay';

const messages = defineMessages({
  title: {
    id: 'crypto.payins.v2.heading.pay_title',
    description: 'Header for the payment screen',
    defaultMessage: 'Pay {businessName}',
  },
  genericTitle: {
    id: 'crypto.payins.v2.heading.pay_with_crypto',
    description: 'Generic header for the payment screen',
    defaultMessage: 'Pay with crypto',
  },
  usdtExchangeFee: {
    id: 'crypto.payins.v2.heading.usdt_exchange_fee',
    description: 'Disclaimer shown when USDT is selected',
    defaultMessage: 'USDT payments include an exchange fee.',
  },
});

export const PayTitle = () => {
  const store = getStore();

  const businessName = store.useSelector(
    (state) => state.merchantBranding.businessName,
  );

  const useGenericTitle = store.useSelector(
    (state) => state.featureFlags.crypto_payins_generic_payment_title,
  );

  const selectedCurrencyAssetCode =
    store.useSelector(
      (state) =>
        state.selectedCurrency?.assetCode ??
        state.directDeposit.selectedDirectDepositCurrency,
    ) || 'usdc';
  const showUsdtDisclaimer = isUsdtAssetCode(selectedCurrencyAssetCode);
  const amountDisplay = useAmountDisplay();

  return (
    <LinkTitleWrapper>
      <Text type="headline">
        {useGenericTitle ? (
          <FormattedMessage {...messages.genericTitle} />
        ) : (
          <FormattedMessage {...messages.title} values={{businessName}} />
        )}
      </Text>

      <Text type="heading">{amountDisplay}</Text>

      {showUsdtDisclaimer ? (
        <Text type="caption" css={{color: 'rgba(26, 26, 26, 0.5)'}}>
          <FormattedMessage {...messages.usdtExchangeFee} />
        </Text>
      ) : null}
    </LinkTitleWrapper>
  );
};
